import { FC, useEffect, useRef } from 'react';
import { clsx } from 'clsx';
import {
  IMappedGroupSchedule,
  IMappedScheduleDateData,
  IMappedTeacherSchedule,
} from 'entities/types';

import { IModalCardScheduleProps } from '../models/IModalCardScheduleProps';

import styles from './styles.module.scss';

const days = [
  'Воскресенье',
  'Понедельник',
  'Вторник',
  'Среда',
  'Четверг',
  'Пятница',
  'Суббота',
];

interface ICardRowProps {
  data: IMappedGroupSchedule | IMappedTeacherSchedule;
  dateData: IMappedScheduleDateData;
  isGroupSchedule: boolean;
}
const CardRow: FC<ICardRowProps> = ({ data, dateData, isGroupSchedule }) => {
  return (
    <div
      className={clsx(
        styles['calendar-schedule__lesson'],
        {
          [styles['calendar-schedule__lesson_blue']]:
            data.disciplType === 'Лабораторная работа',
        },
        {
          [styles['calendar-schedule__lesson_violet']]:
            data.disciplType === 'Практика',
        },
        {
          [styles['calendar-schedule__lesson_red']]:
            data.disciplType === 'Лекция',
        },
      )}
    >
      {!isGroupSchedule && (
        <div
          className={styles['calendar-schedule__tags']}
          title={(data as IMappedTeacherSchedule).groupsTags.join(', ')}
        >
          {(data as IMappedTeacherSchedule).groupsTags.map((tag) => {
            return (
              <div className={styles['calendar-schedule__tag']} key={tag}>
                {tag}
              </div>
            );
          })}
        </div>
      )}
      <div
        className={styles['calendar-schedule__header']}
        title={data.disciplName ? data.disciplName : 'Предмета нет'}
      >
        {data.disciplType === 'Лабораторная работа'
          ? 'Л/р'
          : data.disciplType === 'Практика'
            ? 'Пр'
            : 'Лек'}{' '}
        — {data.disciplName}
      </div>

      <div className={styles['calendar-schedule__descr']}>
        <span className={styles['calendar-schedule____time-interval']}>
          {data.disciplTime}
        </span>
        {dateData.timeInterval.length !== 0 && (
          <div
            className={styles['calendar-schedule___section-2-delimiter']}
          ></div>
        )}
        <span
          className={styles['calendar-schedule___location']}
          title={data.location}
        >
          {data.location}
        </span>
      </div>
    </div>
  );
};

export const ModalCardSchedule: FC<IModalCardScheduleProps> = ({
  dataSchedule,
  dateData,
  isGroupSchedule,
  position,
  onClose,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const mappedDataSchedule = dataSchedule.map((item, index) => {
    return (
      <CardRow
        data={item}
        dateData={dateData}
        isGroupSchedule={isGroupSchedule}
        key={index}
      />
    );
  });

  useEffect(() => {
    const handleClickOutside = () => {
      if (modalRef.current) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      className={clsx(styles['calendar-schedule__modal-card'])}
      ref={modalRef}
      style={{
        position: 'absolute',
        left: `${position.x}px`,
        top: `${position.y}px`,
        zIndex: 1000,
        maxWidth: '350px',
      }}
    >
      <div className={clsx(styles['calendar-schedule__date'])}>
        {days[dataSchedule[0].date.day()]}{' '}
        <span className={styles['calendar-schedule__date-lessons-quantity']}>
          — {dataSchedule.length}
        </span>
      </div>
      <div className={clsx(styles['calendar-schedule__lessons'])}>
        {mappedDataSchedule}
      </div>
    </div>
  );
};
